/**
 * Hlasová upozornění navigace (2026-10-23).
 *
 * V aplikaci mluví Android (NastaveniTelefonu.rict — hlas navigace, ztlumí
 * hudbu), v prohlížeči Web Speech API. Starší APK bez `rict` → Web Speech;
 * když nejde ani to, upozornění zůstane jen na displeji.
 *
 * Nejvýš jedna věta za 8 s; když se sejdou dvě, vyhraje důležitější.
 */
import { PRIORITA } from './motor';

const PAUZA_MS = 8000;
let posledni = 0;
let cekajici = null;
let casovac = null;

function mluv(text) {
    const telefon = window.__FL_APLIKACE?.telefon;
    if (telefon?.rict) {
        telefon.rict(text).then((r) => { if (r == null) mluvWeb(text); });
        return;
    }
    mluvWeb(text);
}

function mluvWeb(text) {
    try {
        const s = window.speechSynthesis;
        if (!s) return;
        s.cancel();
        const u = new SpeechSynthesisUtterance(text);
        u.lang = 'cs-CZ';
        u.rate = 1.05;
        const cesky = s.getVoices().find((v) => v.lang?.toLowerCase().startsWith('cs'));
        if (cesky) u.voice = cesky;
        s.speak(u);
    } catch { /* bez hlasu zůstane upozornění na displeji */ }
}

/** Řekne větu, nebo ji odloží, když se mluvilo před chvílí. */
export function rict(text, typ = 'info') {
    const ted = Date.now();
    const p = PRIORITA[typ] ?? 9;
    if (ted - posledni >= PAUZA_MS) {
        posledni = ted;
        mluv(text);
        return;
    }
    if (!cekajici || p < cekajici.p) cekajici = { text, p };
    if (!casovac) {
        casovac = setTimeout(() => {
            casovac = null;
            if (cekajici) { posledni = Date.now(); mluv(cekajici.text); cekajici = null; }
        }, PAUZA_MS - (ted - posledni));
    }
}

/** Vzdálenost do věty: „sto metrů", „tři sta metrů", „osm set metrů". */
export function metryCesky(m) {
    const z = m < 150 ? Math.round(m / 10) * 10 : Math.round(m / 50) * 50;
    if (z >= 1000) return 'kilometr';
    const sta = { 100: 'sto', 150: 'sto padesát', 200: 'dvě stě', 250: 'dvě stě padesát', 300: 'tři sta', 350: 'tři sta padesát', 400: 'čtyři sta', 450: 'čtyři sta padesát', 500: 'pět set', 550: 'pět set padesát', 600: 'šest set', 650: 'šest set padesát', 700: 'sedm set', 750: 'sedm set padesát', 800: 'osm set', 850: 'osm set padesát', 900: 'devět set', 950: 'devět set padesát' };
    if (sta[z]) return `${sta[z]} metrů`;
    return `${z} metrů`;
}

export const VETA = {
    stopka: (m) => `Stopka za ${metryCesky(m)}.`,
    prednost: (m) => `Dej přednost za ${metryCesky(m)}.`,
    hlavni: (m) => `Vjíždíš na hlavní silnici za ${metryCesky(m)}.`,
    radar: (m) => `Radar za ${metryCesky(m)}.`,
    usek: (m) => `Úsekové měření za ${metryCesky(m)}.`,
    hlidka: (m) => `Hlídka za ${metryCesky(m)}.`,
    nehoda: (m) => `Nehoda na trase za ${metryCesky(m)}.`,
    prekazka: (m) => `Překážka na trase za ${metryCesky(m)}.`,
    novyLimit: (l) => `Pozor, ${l}.`,
    rychle: (v, l) => `Jedeš ${v}, limit ${l}.`,
};
